import { Tab, Tabs as TabsMUI } from '@mui/material';
import { Typography } from '../Typography';
import { getScrollButtonComponent, getTabsClassName } from './helper';
import { TabsProps } from './types';

const Tabs = (props: TabsProps) => {
  const {
    type = 'uncountable',
    tabs,
    onSelect,
    selected,
    className,
    ...restProps
  } = props;

  const isNavigation = type === 'navigation';

  const finalClassName = [getTabsClassName(), className].join(' ');

  return (
    <TabsMUI
      {...restProps}
      variant="scrollable"
      scrollButtons={isNavigation ? true : false}
      value={selected}
      onChange={onSelect}
      // TabIndicatorProps={{ ...getTabIndicatorProps }}
      ScrollButtonComponent={getScrollButtonComponent}
      className={finalClassName}
    >
      {tabs.map((tab) => {
        const isActived = tab.tabId === selected;
        const isDisabled = tab.disabled;

        return (
          <Tab
            LinkComponent="a"
            disableRipple
            disabled={tab.disabled}
            key={tab.tabId}
            label={
              <div
                className={[
                  'flex items-center gap-[6px]',
                  !isActived && 'text-Action/Active',
                  isDisabled && 'text-Text/LightBackground/Disabled',
                ].join(' ')}
              >
                {tab.startAdornment && tab.startAdornment}
                <Typography variant="button2" id={tab.tabId + ''}>
                  {tab.title}
                </Typography>
                {tab.endAdornment && tab.endAdornment}
              </div>
            }
            id={tab.tabId + ''}
            className="px-4 py-[9px] capitalize"
            {...(tab.href && { href: tab.href })}
            {...(tab.value && { value: tab.value })}
          />
        );
      })}
    </TabsMUI>
  );
};

export default Tabs;
